import styled, { css } from 'styled-components';

export const Tabs = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
`;

export const Tab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 36px;

  ${props => props.active ? css`
    color: #465EB6;
    
    border-bottom: 2px solid #465EB6;
    ` : css`
    color: #BDBDBD;
    
    border-bottom: 1px solid #BDBDBD;
    
    cursor: pointer;
  `};

  ${props => props.disabled && css`
    opacity: 0.5;
    cursor: not-allowed;
    background-color: '#8888'
  `}
`;